<template>

  <a-layout class="center-container">

    <a-layout-content class="center-div"
      :style="{ background: '#fff', padding: '75px 50px 50px 50px', margin: 0, minHeight: '720px' }">

      <!-- 内容详情卡片包裹 -->
      <a-card :hoverable="false" :bordered="true" style="padding: 20px;" :bodyStyle="{ padding: '5px' }" :type="'inner'"
        class="card">

        <!-- 文档位置: 面包屑 -->
        <!-- <a-row :gutter="24">
          <a-breadcrumb separator=">" style="margin:0px 0px 20px 10px;">
            <a-breadcrumb-item>
              <router-link :to="'/'">
                首页
              </router-link>
            </a-breadcrumb-item>
            <a-breadcrumb-item>{{ '人工智能' }} </a-breadcrumb-item>
            <a-breadcrumb-item>{{ '基础语法' }}</a-breadcrumb-item>
            <a-breadcrumb-item>{{ 'Python数学' }}</a-breadcrumb-item>
          </a-breadcrumb>
        </a-row> -->

        <!-- 文档详情 -->
        <div>
          <h2>{{ article.title }}</h2>
          <!-- 描述 -->
          <div style="color: #606266">
            <a-typography-paragraph>
              <blockquote>{{ article.description }}</blockquote>
              <!-- <pre>{{  article.description }}</pre> -->
            </a-typography-paragraph>
          </div>
          <div style="margin-top: 10px;">
            <span>阅读数：{{ article.viewCount }}</span> &nbsp; &nbsp;
            <span>点赞数：{{ article.voteCount }}</span>
          </div>
          <a-divider style="height: 2px; background-color: #9999cc" />
        </div>

        <!-- HTML详情 -->
        <div class="wangeditor" :innerHTML="html"></div>

        <!-- 点赞功能 -->
        <div class="vote-div">
          <a-button type="primary" shape="round" :size="'large'" @click="vote">
            <template #icon>
              <LikeOutlined /> &nbsp;点赞：{{ article.voteCount }}
            </template>
          </a-button>
        </div>
      </a-card>
    </a-layout-content>

    <!-- 返回页面顶部的操作按钮。 -->
    <a-back-top type="default" />

    <!-- 页脚 -->
    <div style="margin-top: 0px;width: 100%;">
      <the-footer></the-footer>
    </div>

  </a-layout>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, createVNode } from 'vue';
import axios from 'axios';
import { message } from 'ant-design-vue';
import { Tool } from "@/util/tool";
import { useRoute } from "vue-router";

// 引入代码高亮CSS atom-one-dark-reasonable.css
import 'highlight.js/styles/xcode.css' // xcode.css

import TheFooter from "@/components/the-footer.vue";


export default defineComponent({
  name: 'Doc',
  components: {
    TheFooter
  },
  setup() {
    const route = useRoute();
    const docs = ref();
    const html = ref();

    // 文章Object
    const article: any = ref({})
    console.log('articleId', route.query.articleId)
    /**
     * 查询文章详情
     */
    const handleQuery = () => {

      axios.get("/app/article/detail/" + route.query.articleId).then((response) => {
        const result = response.data;
        if (result.code == 0 && result.message == 'success') {
          article.value = result.data;
          console.log("article ", article.value);
          // 修改HTML
          if (article.value.content != undefined) {
            html.value = article.value.content.content
          }
        } else {
          message.error(result.message);
        }
      });

    };


    /**
     * 点赞
     */
    const vote = () => {
      // 必须有值才可点赞
      if (article.value == undefined || article.value.id == undefined) {
        message.warning('暂无相关文档');
        return
      }
      axios.get('/app/article/vote/' + article.value.id).then((response) => {
        const result = response.data;
        if (result.code == 0 && result.message == 'success') {
          article.value.voteCount++;
          //提示
          message.success("点赞成功");
        } else {
          message.warning(result.message);
        }
      });
    };

    onMounted(() => {

      handleQuery();

    });

    return {
      html,
      vote,
      article
    }
  }
});
</script>

<style>
/* wangeditor默认样式*/
/* table 样式 */
.wangeditor table {
  border-top: 1px solid #ccc;
  border-left: 1px solid #ccc;
}

.wangeditor table td,
.wangeditor table th {
  border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc;
  padding: 3px 5px;
}

.wangeditor table th {
  border-bottom: 2px solid #ccc;
  text-align: center;
}

/* blockquote 样式 */
.wangeditor blockquote {
  display: block;
  border-left: 8px solid #d0e5f2;
  padding: 5px 10px;
  margin: 10px 0;
  line-height: 1.4;
  font-size: 100%;
  background-color: #f1f1f1;
}

/* code 样式 */
.wangeditor code {
  display: inline-block;
  display: inline;
  zoom: 1;
  /* background-color: #f1f1f1; */
  /* code代码块的背景颜色  #F2F6FC EBEEF5 E4E7ED*/
  /* background-color: #F2F6FC; */
  border-radius: 3px;
  padding: 3px 5px;
  margin: 0 3px;
}

.wangeditor pre code {
  display: block;
}

/* ul ol 样式 */
.wangeditor ul,
ol {
  margin: 10px 0 10px 20px;
}

/* 和antdv p冲突，覆盖掉 */
.wangeditor blockquote p {
  font-family: "YouYuan";
  margin: 20px 10px !important;
  font-size: 16px !important;
  font-weight: 600;
}

/* 点赞 */
.vote-div {
  margin-top: 20px;
  padding: 15px;
  text-align: center;
}

/* 图片自适应 */
.wangeditor img {
  max-width: 100%;
  height: auto;

}


/* 视频自适应 */
.wangeditor iframe {
  width: 100%;
  height: 400px;
}

/* --------------------媒体查询,宽屏拉伸时保持居中显示--------------------------- */
/* 基础样式 */
.center-container {
  width: 100%;
  background: #fff;
}

/* 基础样式 */
.center-div {
  width: 100%;
}

/* 屏幕宽度大于或等于1475px时应用的样式 */
@media screen and (min-width: 1475px) {

  .center-container {
    display: flex;
    /* 水平居中 */
    justify-content: center;
    /* 垂直居中 */
    align-items: center;
    /* 父容器的高度设置为视窗高度 */
    /* 加上header高度 */
    height: 100vh + 70px;
  }

  .center-div {
    /* 或者具体的宽度值 */
    width: 1424px;
  }

}
</style>
